import { Link } from 'react-router-dom';
import { Text } from '@querodelivery/uni-react';
import {
  capitalizeFirstLetter,
  convertMetersToKilometers,
  moneyLabel,
} from '@/Utils/FnUtils';
import styles from './delivery-information-box.module.scss';
import {
  ORIGIN_ORDER_TYPE_LABELS,
  type ENUM_ORIGIN_ORDER_TYPE,
} from '../../constants';

interface DeliveryInformationBoxProps {
  deliveryValue?: number;
  totalOrderValue?: number;
  deliverymanFee?: number;
  paymentMethod?: string;
  deliveryType?: string;
  deliveryOrigin?: ENUM_ORIGIN_ORDER_TYPE;
  distance?: number;
  establishmentName?: string;
  pickupAddress?: string;
  change?: number | null;
  establishmentId?: string;
  onCloseModal?: () => void;
}

export const DeliveryInformationBox = ({
  deliveryValue,
  totalOrderValue,
  deliverymanFee,
  paymentMethod,
  deliveryType,
  deliveryOrigin,
  distance,
  establishmentName,
  pickupAddress,
  change,
  establishmentId,
  onCloseModal,
}: DeliveryInformationBoxProps) => {
  const formatteddeliveryValue = deliveryValue
    ? moneyLabel(deliveryValue)
    : '- - -';
  const formattedTotalOrderValue = totalOrderValue
    ? moneyLabel(totalOrderValue)
    : '- - -';
  const formatteddeliverymanFee = deliverymanFee
    ? moneyLabel(deliverymanFee)
    : '- - -';
  const changeFormatted = change ? moneyLabel(change) : '- - -';
  const formattedDistance = distance
    ? `${convertMetersToKilometers(distance)} km`
    : '- - -';
  const formattedPaymentMethod = paymentMethod
    ? capitalizeFirstLetter(paymentMethod)
    : '- - -';

  const deliveryOriginUpper = deliveryOrigin?.toUpperCase();

  const formattedOriginType = deliveryOriginUpper
    ? ORIGIN_ORDER_TYPE_LABELS[deliveryOriginUpper as ENUM_ORIGIN_ORDER_TYPE] ||
      deliveryOriginUpper
    : '- - -';

  return (
    <div className={styles.container}>
      <Text
        fontSize="md"
        lineHeight="lg"
        fontWeight="semibold"
        tone="supporting"
      >
        Detalhes da Entrega
      </Text>

      <div className={styles.valuesContainer}>
        <div className={styles.orderValueContainer}>
          <span className={styles.orderValue}>{formatteddeliveryValue}</span>
          <span className={styles.orderValueLabel}>Valor da entrega</span>
        </div>

        <div className={styles.orderValueContainer}>
          <span className={styles.orderValue}>{formattedTotalOrderValue}</span>
          <span className={styles.orderValueLabel}>Valor total do pedido</span>
        </div>

        <div className={styles.orderValueContainer}>
          <span className={styles.orderValue}>{formatteddeliverymanFee}</span>
          <span className={styles.orderValueLabel}>Taxa do entregador</span>
        </div>
      </div>

      <div className={styles.orderInformationContainer}>
        <div className={styles.orderInformation}>
          {change && (
            <div>
              <span>Troco</span>
              <span>{changeFormatted}</span>
            </div>
          )}
          <div>
            <span>Forma de pagamento</span>
            <span>{formattedPaymentMethod}</span>
          </div>
          <div>
            <span>Tipo</span>
            <span>{deliveryType}</span>
          </div>
          <div>
            <span>Origem da entrega</span>
            <span>{formattedOriginType}</span>
          </div>
          <div>
            <span>Distância</span>
            <span>{formattedDistance}</span>
          </div>
          <div>
            <span>Estabelecimento</span>

            <span>
              <Link
                to={`/estabelecimentos/${establishmentId}`}
                onClick={() => onCloseModal?.()}
              >
                {establishmentName}
              </Link>
            </span>
          </div>
          <div>
            <span>Endereço da coleta</span>
            <span>{pickupAddress}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
